<template>
    <div class="gmf-product-selector">
        <div class="gmf-product-selector-list gmf-mb-4" v-if="modelValue.length > 0">
            <div v-for="product in modelValue" :key="product.id" class="gmf-product-selector-item">
                <img :src="product.imageUrl" />
                <div class="gmf-product-selector-item-name">{{ getLocalizedString(product.name) }}</div>
                <a href="#" @click.prevent="removeProduct(product)"><Icon icon="delete" /></a>
            </div>
        </div>
        <button class="gmf-btn gmf-btn-sm gmf-btn-secondary" @click="openModal"><Icon icon="pro" /> {{ t('comments.form_v2.default.linkedProducts.add_button') }}</button>
        <Modal v-model="isModalOpen" :stackModals="true">
            <div style="width: 500px; max-width: 100%;">
                <div class="gmf-subheader">{{ t('comments.form_v2.default.linkedProducts.modal_header') }}</div>
                <TextInput v-model="search" label="Search products" :autofocus="true" class="gmf-mb-3" />
                <div class="gmf-product-selector-list">
                    <div v-for="option in options" :key="option.id" class="gmf-product-selector-item gmf-clickable" @click="toggleProduct(option)">
                        <img :src="option.imageUrl" />
                        <div class="gmf-product-selector-item-name">{{ getLocalizedString(option.name) }}</div>
                        <Checkbox :modelValue="selectedProductsMap[option.id]" style="pointer-events: none;" />
                    </div>
                </div>
                <div class="gmf-center gmf-mt-4">
                    <button class="gmf-btn gmf-btn-primary" @click="isModalOpen = false">{{ t('comments.form_v2.default.linkedProducts.add_button') }}</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<style>
.gmf-product-selector-list {
    display: flex;
    flex-direction: column;
    gap: var(--gmf-p-4);
}

.gmf-product-selector button {
    display: inline-flex;
    align-items: center;
    gap: var(--gmf-p-2);
}

.gmf-product-selector-item {
    display: flex;
    gap: var(--gmf-p-3);
    align-items: center;
}

.gmf-product-selector-item img {
    width: 48px;
    height: 48px;
    object-fit: contain;
}
.gmf-product-selector-item-name {
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<script>
import Modal from '@/components/Modal.vue';
import TextInput from '@/components/input/TextInput.vue';
import Checkbox from '@/components/Checkbox.vue';
import callApi from '@/utils/callApi';
import { getLocalizedString } from '@/utils/getLocalizedString';
import Icon from '@/components/Icon.vue';
import debounce from '@/utils/debounce';
import state from '@/state';

export default {
    components: {
        Modal,
        TextInput,
        Checkbox,
        Icon,
    },
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
            isModalOpen: false,
            search: '',
            options: [],
            debouncedSearchProducts: null,
        };
    },
    mounted () {
        this.debouncedSearchProducts = debounce(this.searchProducts, 250);
    },
    computed: {
        selectedProductsMap() {
            const map = {};
            for (const product of this.modelValue) {
                map[product.id] = product;
            }
            return map;
        },
    },
    methods: {
        t: state.t,
        getLocalizedString,
        openModal() {
            this.isModalOpen = true;
            this.searchProducts();
        },
        async searchProducts () {
            const params = new URLSearchParams();
            if (this.search) {
                params.set('q', this.search);
            }
            params.set('take', '10');
            const res = await callApi('GET', '/v3/products/search?' + params.toString());
            const data = await res.json();
            this.options = data.results;
        },
        toggleProduct(product) {
            if (this.selectedProductsMap[product.id]) {
                this.removeProduct(product);
            } else {
                this.addProduct(product);
            }
        },
        addProduct(product) {
            const newValue = this.modelValue ? this.modelValue.slice(0) : [];
            newValue.push(product);
            this.$emit('update:modelValue', newValue);
        },
        removeProduct(product) {
            let newValue = this.modelValue ? this.modelValue.slice(0) : [];
            newValue = newValue.filter(p => p.id !== product.id);
            this.$emit('update:modelValue', newValue);
        },
    },
    watch: {
        search () {
            if (this.isModalOpen) {
                this.debouncedSearchProducts();
            }
        },
    },
}
</script>